export const setErrors = (errors: any, setError: any) => {
  Object.keys(errors).forEach((key) => {
    setError(
      key,
      {
        type: 'server side',
        message: errors[key].join('\n '),
      },
      { shouldFocus: true }
    );
  });
};
